import { ROUTE_PATH } from "common/constants/sm-constants";
import { FormMetaModel, SmMetaInputModel, SmDatepickerModel, SmMetaFileModel, SmBtnMetaModel } from "common/models/utility-models/meta-model";

export class TravelReimbursementMetaModel extends FormMetaModel {
    constructor() {
        super('Add Travel Reimbursement Details', ROUTE_PATH.travelReimbursement, ROUTE_PATH.addTravelReimbursement, 3, '', false, '', '', 'row align-items-start');
    }

    override initProperties(): any {
        const formInfo = super.initProperties();
        const travelTitleOrRemark = new SmMetaInputModel(
            'travelTitleOrRemark',
            'travelTitleOrRemark',
            'input',
            true,
            'col-12 col-md-4 mb-2',
            1,
            1,
            'Title',
            'text',
            '',
            false,
            true,
            true,
            false,
            100,
            1
        );
        const travelStartDate = new SmDatepickerModel(
            'travelStartDate',
            'travelStartDate',
            // 'datepicker',
            // true,
            // 'col-12 col-md-4 mb-2',
            // 1,
            // 2,
            // 'Start',
            // 'text',
            // '',
            // false,
            // true,
            // true,
            // false,
            // false,
            // 'DD/MM/YYYY',
            // '',
            // [],
            // false
            'datepicker',
            true,
            'col-12 col-md-4',
            1,
            1,
            'Start Date',
            'text',
            '',
            false,
            true,
            true,
            false,
            false,
            'DD/MM/YYYY',
            '01/01/1970',
            [],
            false,
        );


        const travelEndDate = new SmDatepickerModel(
            'travelEndDate',
            'travelEndDate',
            'datepicker',
            true,
            'col-12 col-md-4',
            1,
            3,
            'End Date',
            'text',
            '',
            false,
            true,
            true,
            false,
            false,
            'DD/MM/YYYY',
            '01/01/1970',
            [],
            false
        );
        const travelDoc = new SmMetaFileModel(
            'travelDoc',
            'travelDoc',
            'file',
            true,
            'input-fg col-6 col-md-6',
            2,
            4,
            'Upload Travel Reimbursement Document (only pdf, image, word, excel files allowed)',
            'PDF',
            '',
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            ['pdf', 'xls', 'xlsx', 'doc', 'docx', 'jpg', 'jpeg', 'png', 'svg', 'webp'],
            3000,
            250,
            510,
            'travelDoc',
            'travelDoc',
            false,
            false,
            2000,
            3000
        );



        const buttons = {
            submit: new SmBtnMetaModel('Submit', '', true, false, true, true),
            isFormControl: false
        };


        return {
            formInfo,
            buttons,
            travelTitleOrRemark,
            travelStartDate,
            travelEndDate,
            travelDoc

        }
    }
}